const parseBacValue = value => {
  if (value === null || value === undefined || value === "") return null;
  const stringValue = String(value).trim();
  if (!stringValue) return null;
  const numericValue = Number.parseFloat(stringValue.replace("%", ""));
  if (Number.isNaN(numericValue)) return null;
  return stringValue.includes("%") && numericValue > 1
    ? numericValue / 100
    : numericValue;
};

const shouldAutoCheckIntentBacResult = data =>
  parseBacValue(data?.alcoholConcentration) >= 0.08;

const shouldAutoCheckCommercialBacResult = data =>
  !!data?.isCommercialVehicle &&
  parseBacValue(data?.alcoholConcentration) >= 0.04;

export {
  parseBacValue,
  shouldAutoCheckCommercialBacResult,
  shouldAutoCheckIntentBacResult,
};
